var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3584 0.00242437C23.6944 0.141263 18.3996 0.646618 15.131 2.48411C14.9054 2.61089 14.7775 2.83634 14.7775 3.07205V19.3162C14.7775 19.8318 15.3915 20.1577 15.9092 19.9184C19.2722 18.3639 24.1358 17.9398 26.5407 17.8238C27.3617 17.784 28 17.1796 28 16.455V1.37295C28.0005 0.582332 27.2538 -0.044004 26.3584 0.00242437ZM12.869 2.48411C9.60086 0.646618 4.30605 0.141709 1.64211 0.00242437C0.74668 -0.044004 0 0.582332 0 1.37295V16.4555C0 17.1805 0.638275 17.7849 1.45933 17.8242C3.86514 17.9403 8.73119 18.3648 12.0942 19.9202C12.6104 20.159 13.2225 19.8336 13.2225 19.3193V3.06402C13.2225 2.82786 13.0951 2.61134 12.869 2.48411Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.59e32ad6197ddb62d0a408c90b89e11a.svg";
export { ForwardRef as ReactComponent };